export const darkTheme = {
  mode: "dark",
  bg: "#06080f", // slightly deeper space 
  bgLight: "#0a0e1c",
  primary: "#00f0ff",
  secondary: "#00c3ff",
  text_primary: "#f0f2f5",
  text_secondary: "#858d99",
  card: "rgba(10, 14, 28, 0.7)",
  card_light: "rgba(15, 20, 40, 0.6)",
  card_border: "rgba(0, 240, 255, 0.15)",
  button: "#00f0ff",
  white: "#ffffff",
  black: "#000000",
};

export const lightTheme = {
  mode: "light",
  bg: "#f0f2f5",
  bgLight: "#ffffff",
  primary: "#0070bc",
  secondary: "#004b80",
  text_primary: "#111418",
  text_secondary: "#5c6570",
  card: "rgba(255, 255, 255, 0.9)",
  card_light: "rgba(240, 242, 245, 0.8)",
  card_border: "rgba(0, 112, 188, 0.15)",
  button: "#0070bc",
  white: "#ffffff",
  black: "#000000",
};
